// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UNpR","tabsBox":"styles_tabsBox__2tFuK","createButton":"styles_createButton__2KJLA"};